export const rem = (size: number): string => `${size / 16}rem`

export const COLORS = {
  WHITE: '#FFFFFF',

  // Backgrounds
  BG_DARK: '#0F264E',
  BG_DIVIDER: '#C9CED8',
  BG_DARK_DIVIDER: '#A3ADBE',
  BG_DISABLED: '#E2E2E2',
  BG_SOFT: '#F0F3FA',

  // Texts
  TXT_MAIN: '#0F264E',
  TXT_DEFAULT: '#525E72',
  TXT_DISABLED: '#97A0B0',
  TXT_PLACEHOLDER: '#828D9F',

  // Brand
  BRAND_DEFAULT: '#175EDC',
  BRAND_HOVER: '#124BB0',
  BRAND_PRESSED: '#0E3884',
  BRAND_LIGHT: '#E3ECFB',

  // Error
  ERROR_DEFAULT: '#F33636',
  ERROR_HOVER: '#C22B2B',
  ERROR_PRESSED: '#922020',
  ERROR_LIGHT: '#FFF0F0',

  // Success
  SUCCESS_DEFAULT: '#14C650',
  SUCCESS_HOVER: '#109E40',
  SUCCESS_PRESSED: '#0C7730',
  SUCCESS_LIGHT: '#E3F8EA',

  // Warning
  WARNING_DEFAULT: '#F2901D',
  WARNING_HOVER: '#C27317',
  WARNING_PRESSED: '#915611',
  WARNING_LIGHT: '#FEF2E4',

  // Button dark
  DARK_DEFAULT: '#20BCFF',
  DARK_HOVER: '#65D1FF',
  DARK_PRESSED: '#59a4da',

  // Dark
  DARK_BG_DARK: '#10264e',
  DARK_BG_LIGHT: '#2c4064',
  DARK_BG_DEFAULT: '#465676',
  DARK_DIVIDER: '#9fa8b9',
  DARK_TXT_PLACEHOLDER: '#bcc3ce',
  DARK_TXT_DEFAULT: 'white',
}

export const fontSizes = {
  xs: rem(12),
  s: rem(14),
  m: rem(16),
  l: rem(18),
  xl: rem(20),
  xxl: rem(24),
  xxxl: rem(32),
  xxxxl: rem(40),
}

export const lineHeights = {
  xs: rem(16),
  s: rem(24),
  m: rem(24),
  l: rem(24),
  xl: rem(28),
  xxl: rem(32),
  xxxl: rem(40),
  xxxxl: rem(56),
}

export const BOXSHADOWS = {
  LEVEL_0: `0px 2px 8px rgba(0, 0, 0, 0.08);`,
  LEVEL_1: '0px 4px 12px rgba(0, 0, 0, 0.08)',
  LEVEL_2: '0px 8px 24px rgba(0, 0, 0, 0.08)',
  LEVEL_3: '0px 12px 32px rgba(0, 0, 0, 0.12)',
}
